import React from 'react';
import { Crown } from 'lucide-react';

interface VipBadgeProps {
  label?: string;
}

const VipBadge: React.FC<VipBadgeProps> = ({ label = 'VIP' }) => (
  <div className="bg-gradient-to-r from-fuchsia-500 to-fuchsia-700 text-white text-xs px-3 py-1 rounded-full flex items-center z-10 shadow-lg border border-fuchsia-300">
    <Crown className="h-3 w-3 mr-1" />
    {label}
  </div>
);

export default VipBadge;
